// @flow

import type { ElementProps, Node, Element } from 'react';

import { Component } from 'react';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';
import { Input } from 'dibs-elements/exports/Input';
import { NumberInput } from 'dibs-elements/exports/NumberInput';
const INPUT_SIZE = 'large';

type BasicSelectProps = ElementProps<typeof BasicSelect>;
type InputProps = ElementProps<typeof Input>;
type NumberInputProps = ElementProps<typeof NumberInput>;
type DynamicInputProps = {|
    dataTn: string,
    disabled?: boolean,
    errorMessage: ?Node | {| __html: string |},
    hasAnimatedPlaceholder?: boolean,
    inputType: 'select' | 'text' | 'number',
    label?: string,
    leftDecorator?: string | Element<any>,
    placeholder?: string,
    onChange?: (e: SyntheticEvent<*>) => void,
    value?: string,
    options: $ElementType<BasicSelectProps, 'options'>,
    rightDecorator?: string | Element<any>,
    size?: $ElementType<BasicSelectProps, 'size'>,
|};

export class DynamicInput extends Component<DynamicInputProps> {
    getBasicSelectProps(): BasicSelectProps {
        const {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder,
            label,
            onChange,
            options,
            placeholder,
            value,
            size,
        } = this.props;

        return {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder:
                typeof hasAnimatedPlaceholder === 'boolean' ? hasAnimatedPlaceholder : true,
            label,
            ...(onChange ? { onChange } : null),
            options,
            placeholder,
            size: size || INPUT_SIZE,
            value,
        };
    }
    getInputProps(): InputProps {
        const {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder,
            label,
            onChange,
            placeholder,
            value,
            size,
            leftDecorator,
            rightDecorator,
        } = this.props;

        return {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder:
                typeof hasAnimatedPlaceholder === 'boolean' ? hasAnimatedPlaceholder : true,
            label,
            leftDecorator,
            ...(onChange ? { onChange } : null),
            placeholder,
            rightDecorator,
            size: size || INPUT_SIZE,
            value,
        };
    }
    getNumberInputProps(): NumberInputProps {
        const {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder,
            label,
            onChange,
            placeholder,
            value,
            size,
            leftDecorator,
            rightDecorator,
        } = this.props;

        return {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder:
                typeof hasAnimatedPlaceholder === 'boolean' ? hasAnimatedPlaceholder : true,
            label,
            leftDecorator,
            ...(onChange ? { onChange } : null),
            placeholder,
            rightDecorator,
            size: size || INPUT_SIZE,
            value,
        };
    }
    render() {
        const { inputType } = this.props;

        switch (inputType) {
            case 'select': {
                return <BasicSelect {...this.getBasicSelectProps()} />;
            }
            case 'text': {
                return <Input {...this.getInputProps()} />;
            }
            case 'number': {
                return <NumberInput {...this.getNumberInputProps()} />;
            }
            default: {
                return <BasicSelect {...this.getBasicSelectProps()} />;
            }
        }
    }
}
